module.exports = __webpack_public_path__ + "img/quiz_complete_icon.81da6470.png";